<template>
  <div class="chat-container">
    <div
      class="chat"
      :class="this.toolVisible ? 'chat-margin-bottom' : ''"
    >
      <!-- <div class="chat-item self">
                <div class="main">
                    <div class="content">
                        <p>
                            <span>喵喵喵！喵喵喵！喵喵喵！喵喵！喵喵！！喵！喵喵喵！</span>
                        </p>
                    </div>
                </div>
                <van-image
                    width="1.28rem"
                    height="1.28rem"
                    fit="cover"
                    radius="0.12rem"
                    lazy-load
                    src="https://img.yzcdn.cn/vant/cat.jpeg"
                />
                <div class="date">2018年3月23日 13:23</div>
            </div>
            <div class="chat-item">
                <van-image
                    width="1.28rem"
                    height="1.28rem"
                    fit="cover"
                    radius="0.12rem"
                    lazy-load
                    src="https://img.yzcdn.cn/vant/cat.jpeg"
                />
                <div class="main">
                    <div class="content">
                        <p>
                            <span>喵喵喵！喵喵喵！喵喵喵！喵喵！喵喵！！喵！喵喵喵！</span>
                        </p>
                    </div>
                </div>
                <div class="date">13:23</div>
            </div>
            <div class="chat-item self">
                <div class="main">
                    <van-image
                        fit="cover"
                        radius="0.12rem"
                        lazy-load
                        src="https://img.yzcdn.cn/vant/cat.jpeg"
                    />
                </div>
                <van-image
                    width="1.28rem"
                    height="1.28rem"
                    fit="cover"
                    radius="0.12rem"
                    lazy-load
                    src="https://img.yzcdn.cn/vant/cat.jpeg"
                />
                <div class="date">2018年3月23日 13:23</div>
            </div>
            <div class="chat-item self">
                <div class="main">
                    <van-image
                        fit="cover"
                        radius="0.12rem"
                        lazy-load
                        src="https://img.yzcdn.cn/vant/cat.jpeg"
                    />
                </div>
                <van-image
                    width="1.28rem"
                    height="1.28rem"
                    fit="cover"
                    radius="0.12rem"
                    lazy-load
                    src="https://img.yzcdn.cn/vant/cat.jpeg"
                />
                <div class="date">2018年3月23日 13:23</div>
            </div>
            <div class="chat-item self">
                <div class="main">
                    <van-image
                        fit="cover"
                        radius="0.12rem"
                        lazy-load
                        src="https://img.yzcdn.cn/vant/cat.jpeg"
                    />
                </div>
                <van-image
                    width="1.28rem"
                    height="1.28rem"
                    fit="cover"
                    radius="0.12rem"
                    lazy-load
                    src="https://img.yzcdn.cn/vant/cat.jpeg"
                />
                <div class="date">2018年3月23日 13:23</div>
            </div>-->
      <div
        class="loading"
        v-if="loading"
      >
        <van-loading
          size="0.64rem"
          color="var(--grey)"
        />
      </div>
      <template v-for="(item, index) in message">
        <div
          v-if="_.indexOf(['text', 'image'], item.type) > -1"
          :key="`${index}-item`"
          class="chat-item"
          :id="item.id"
          :class="item.form === userInfo.id ? 'self' : ''"
        >
          <van-image
            v-if="item.form != userInfo.id"
            width="1.28rem"
            height="1.28rem"
            fit="cover"
            radius="0.12rem"
            lazy-load
            :src="medicalRecord.headImgUrl"
          />
          <div class="main">
            <div>
              <van-image
                v-if="'image' === item.type"
                fit="cover"
                radius="0.12rem"
                @load="anchor()"
                :src="item.message"
                @click="previewImage(item.message)"
              />
            </div>
            <div
              v-if="'text' === item.type"
              class="content"
            >
              <div style="width: 100%; word-break: break-all">
                <span>{{ item.message }}</span>
              </div>
            </div>
          </div>
          <van-image
            v-if="item.form === userInfo.id"
            width="1.28rem"
            height="1.28rem"
            fit="cover"
            radius="0.12rem"
            :src="userInfo.headImgUrl"
          />
          <div class="date">{{ item.createTime }}</div>
        </div>
        <div
          v-if="'action' === item.type"
          :key="`${index}-info`"
          class="chat-info"
        >
          {{ item.message }}
        </div>
      </template>
    </div>
    <div class="footer">
      <div class="bar">
        <div class="action">
          <!-- <van-icon
                        class-prefix="hyd-icon"
                        size="0.7rem"
                        name="yuyin"
                    /> -->
        </div>
        <div class="input">
          <div class="input-wrapper">
            <div class="input-placeholder"></div>
            <input
              maxlength="250"
              v-model.trim="text"
              autocomplete="off"
              class="input-input"
              @focus="
                                () => {
                                    this.toolVisible = false;
                                    this.anchor();
                                }
                            "
            />
          </div>
        </div>
        <div class="action">
          <van-icon
            @click="more"
            v-show="!text"
            class-prefix="hyd-icon"
            size="0.8rem"
            name="xinjian"
          />
          <van-button
            @click="sendText"
            v-show="text"
            color="var(--primary)"
            size="small"
          >
            <template #default>
              <span>发送</span>
            </template>
          </van-button>
        </div>
      </div>
      <div class="border-bottom"></div>
      <div
        class="tools-overlay"
        v-if="toolVisible"
        @click="more"
      ></div>
      <div
        class="tools"
        v-show="toolVisible"
      >
        <van-grid
          :border="false"
          clickable
        >
          <van-grid-item text="相册">
            <template #icon>
              <van-uploader
                :max-size="5000 * 1024"
                @oversize="onOversize"
                :after-read="afterRead"
              >
                <div class="upload-photo">
                  <van-icon name="photo-o" />
                </div>
              </van-uploader>
            </template>
          </van-grid-item>
          <van-grid-item
            text="音视频"
            @click="audio"
          >
            <template #icon>
              <div class="upload-photo">
                <van-icon name="video-o" />
              </div>
            </template>
          </van-grid-item>
        </van-grid>
      </div>
    </div>
    <a id="anchor" />
  </div>
</template>


<script>
import Stomp from 'stompjs';
import officialApi from '@/api/officialApi';
import { ImagePreview } from 'vant';

export default {
  name: 'medical_online_consult',
  data () {
    return {
      userInfo: this.$hdk.userInfo(),
      finished: false,
      text: '',
      toolVisible: false,
      client: null,
      message: [],
      total: 0,
      page: 1,
      limit: 20,
      loading: true
    };
  },
  created () {
    console.log('medicalRecord', this.medicalRecord)
    this.$route.meta.title = `与${this.medicalRecord.doctorName}的在线咨询`;
    this.init();
  },
  mounted () {
    window.addEventListener('scroll', this.scrollHandle);
    window.addEventListener('beforeunload', this.beforeunloadHandler);
  },
  beforeDestroy () {
    this.beforeunloadHandler();
    window.removeEventListener('beforeunload', this.beforeunloadHandler);
    window.removeEventListener('scroll', this.scrollHandle);
  },
  methods: {
    scrollHandle (e) {
      const { message, loading, finished, page } = this;
      const top = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset;
      if (0 === top && page != 1 && !loading && !finished) {
        this.loading = true;
        this.messageLoadHandle().then(() => {
          document.getElementById(_.head(message).id).scrollIntoView(true);
          this.loading = false;
        });
      }
    },
    beforeunloadHandler (e) {
      const { client } = this;
      client.disconnect(() => {
        console.log('关闭连接');
      });
    },
    more () {
      this.toolVisible = !this.toolVisible;
      this.anchor();
    },
    anchor () {
      this.$nextTick(() => {
        document.getElementById('anchor').scrollIntoView(true);
      });
    },
    init () {
      const { $setter } = this;
      const ws = new WebSocket($setter.chatWs),
        client = Stomp.over(ws),
        { onConnect, messageLoadHandle } = this;

      client.connect(this.$hdk.token(), '', () => {
        onConnect();
      }, (frame) => {
        console.log('连接失败');
      }, '/');

      this.client = client;
      this.loading = true;
      this.messageLoadHandle().then(() => {
        this.anchor();
      }).finally(() => {
        this.loading = false;
      })
    },
    onConnect () {
      const { client, onMessage, medicalRecord } = this;
      client.subscribe(`/exchange/exchange.hlwyy.chat/${medicalRecord.medicalSession.patientRoutingKey}`, (msg) => {
        onMessage(msg);
      }, {
        'x-queue-name': medicalRecord.medicalSession.patientQueue,
        'auto-delete': true,
        'durable': true
      });
    },
    onMessage (msg) {
      const { message } = this;
      let body = JSON.parse(msg.body);
      body.createTime = '刚刚';
      this.message = _.concat(this.message, [body]);
      this.anchor();
    },
    sendText () {
      const { text, medicalRecord } = this;
      const msg = {
        message: text,
        type: 'text',
        medicalRecordId: medicalRecord.medicalRecordId,
        to: medicalRecord.doctorUserId
      };
      this.text = '';
      this.send(msg);
    },
    sendImage (url) {
      const { medicalRecord } = this;
      const msg = {
        message: url,
        type: 'image',
        medicalRecordId: medicalRecord.medicalRecordId,
        to: medicalRecord.doctorUserId
      };
      this.send(msg);
    },
    send (msg) {
      const { medicalRecord } = this;
      officialApi.sendMessage(medicalRecord.medicalSession.doctorRoutingKey, msg).then(res => {
        const data = res.data;
        this.message = _.concat(this.message, [data]);
      }).catch(() => {

      }).finally(() => {
        this.anchor();
      });
    },
    messageLoadHandle () {
      const { page, limit, medicalRecord } = this;
      return new Promise((resolve, reject) => {
        officialApi.queryMedicalChatRecord(page, limit, medicalRecord.medicalRecordId).then(res => {
          this.message = _.concat(res.data.list.reverse(), this.message);
          this.total += limit;
          if (this.total >= res.data.total) {
            this.finished = true;
          }
          if (!this.finished) {
            this.page++;
          }
          resolve();
        }).catch(() => {
          rejects();
        }).finally(() => {

        });
      });
    },
    previewImage (path) {
      ImagePreview({
        images: [
          path
        ]
      });
    },
    onOversize () {
      this.$toast('文件大小不能超过 5MB');
    },
    afterRead (file) {
      officialApi.uploadChatImage(file.file).then(res => {
        this.sendImage(res.data);
        this.toolVisible = false;
      }).catch(() => {

      });
    },
    audio () {
      const { medicalRecord, userInfo } = this
      window.location = `https://hlwyy.hydimi.com:8443/trtc/#/?roomId=${medicalRecord.doctorId}&userId=${userInfo.id}&key=${medicalRecord.medicalSession.patientAudioKey}`
    }
  },
  props: {
    medicalRecord: {
      type: Object,
      required: true
    }
  }
};
</script>



<style lang="less" scoped  src="./index.less" ></style>